<template>
      <v-dialog
        v-model="virtualDiolog"
        scrollable
        max-width="500px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="warning"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Opcionais por produto
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="card-header">
            <div class="card-header-items">
              <span>
                Opcionais por produto
              </span>

              <v-btn
                color="primary"
                  @click="() => adicionarOpcao()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>

            <div class="card-header-items">
              <span>
                Permitir multiseleção?
              </span>

              <v-checkbox
                v-model="multiselecao"
              ></v-checkbox>
            </div>

            <div style="color:red;font-size:12px;">*Estes Itens não serão integrados, servem somente como informativo*</div>

          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px; margin-top: 1em">
            <div v-for="(opcao, index) in opcoes" :key="opcao.id">

              <v-row>
                <v-col cols="9">
                  <v-text-field
                      v-model="opcao.descricao"
                      label="Descrição"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-dialog
                      v-model="virtualDiologMotivoRemocao"
                      persistent
                      max-width="600px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => removerOpcao(index)"
                      >
                        <v-icon color="white">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">Por favor insira o motivo de exclusão</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                  v-model="motivoRemocao"
                                  label="Motivo"
                                  required
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="() => diologMotivoRemocao = false"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="() => confirmarRemocao(index)"
                        >
                          Confirmar e remover
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions style="display: flex; flex-direction: row;justify-content: flex-end; align-items: center">
            <v-btn
              color="primary"
              @click="() => { this.virtualDiolog = false}"
            >
              Fechar
            </v-btn>
            <v-btn
              color="success"
              @click="salvar"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>

<script>
export default {
  data () {
    return {
        diologMotivoRemocao: false,
        opcoes: [],
        motivoRemocao: "",
        dialog: false,
        multiselecao: false,

        virtualDiologMotivoRemocao: false,
        virtualDiolog: false,
    }
  },
  props: [
    "idproduto"
  ],
  mounted() {
    this.carregaOpcoes();
  },
  watch: {
    diologMotivoRemocao: function(val) {
      this.virtualDiologMotivoRemocao = val;
    },
    diolog: function(val) {
      this.virtualDiolog = val;
    }
  },
  methods: {
    async carregaOpcoes() {
      this.$http.get(`pdv/opcoesProduto/${this.idproduto}/true`)
          .then((res) => {
            this.opcoes = res.data?.opcoes || [];
            this.multiselecao = res.data?.configuracao?.multiselecao;
          })
          .catch(() => {
            this.$alertar("warning", "Erro", "Erro ao carregar opcionais por produto!")
          });
    },
    async salvar() {
      const data = {
        opcoes: this.opcoes.filter((opcao) => opcao.descricao.trim() !== ""),
        multiselecao: this.multiselecao,
      }

      await this.$http.put(`pdv/opcoesProduto/${this.idproduto}`, data)
          .then(async () => {
            await this.carregaOpcoes();
            this.$alertar("success", "Sucesso", "Opcionais por produto salvo com sucesso!")
          })
          .catch(() => {
            this.$alertar("warning", "Erro", "Erro ao salvar opcionais por produto!")
          });
    },
    async removerOpcao(index) {
      const item = this.opcoes[index];
      if(item.id) {
        this.diologMotivoRemocao = true;
      } else {
        this.opcoes.splice(index, 1);
      }
    },
    async confirmarRemocao(index) {
      const item = this.opcoes[index];
      const data =  {
        dadosRemocao: {
          id: item.id,
          motivoremocao: this.motivoRemocao,
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario")
        }
      }
      await this.$http.put(`pdv/removerOpcao/${item.id}`, data)
          .then(() => {
            this.opcoes.splice(index, 1);
          })
          .catch((err) => {
            this.$alertar("warning", "Erro", err.response?.data?.message || "Erro ao remover opcional!")
          })

      this.diologMotivoRemocao = false;
      this.motivoRemocao = "";
    },
    adicionarOpcao() {
      this.opcoes.push(
          {
            id: null,
            idproduto: this.idproduto,
            descricao: "",
            ativo: true,
            id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario")
          }
      );
    },
  }

}
</script>


<style>

  .card-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .card-header-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

</style>
